__turbopack_context__.v({
  "wrapper": "PresenterInfo-module-scss-module__lyZ0NW__wrapper",
});
